var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIngresar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,150C5,230,70,295,150,295s145-65,145-145C295,70,230,5,150,5S5,70,5,150z M262.6,150 c0,62.1-50.5,112.6-112.6,112.6c-56.6,0-103.4-42-111.3-96.4h122.6l-29.6,29.6c-6.3,6.3-6.3,16.6,0,22.9c6.3,6.3,16.6,6.3,22.9,0 l57.2-57.2c1.5-1.5,2.7-3.3,3.5-5.3c0-0.1,0-0.2,0.1-0.2c0.7-1.8,1.1-3.8,1.1-5.9c0-2.1-0.4-4.1-1.1-5.9c0-0.1,0-0.2-0.1-0.2 c-0.8-2-2-3.8-3.5-5.3l-57.2-57.2c-6.3-6.3-16.6-6.3-22.9,0c-6.3,6.3-6.3,16.6,0,22.9l29.6,29.6H38.7C46.6,79.4,93.4,37.4,150,37.4 C212.1,37.4,262.6,87.9,262.6,150z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngresar);
export default __webpack_public_path__ + "static/media/ingresar.2bbb877965dd83356d339b05c6d5a7ea.svg";
export { ForwardRef as ReactComponent };